
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class QueueMember extends Resource {
    public override type = 'queueMembers';

    @prop()
    public queueName!: string;

    @prop()
    public queueId!: string;

    @prop()
    public membername?: string;

    @prop()
    public interface!: string;

    @prop()
    public penalty?: number;

    @prop()
    public paused?: number;

    @prop()
    public ringinuse?: string;
}
